/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Resync_TitleInputs */



/**
* | output |
* | --- |
* | "Resync local data" |
*
* @param {Profile_Resync_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_resync_title = /** @type {((inputs?: Profile_Resync_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Resync_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resynchroniser les données locales")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resincronizar datos locales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ressincronizar dados locais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risincronizza dati locali")
	return /** @type {LocalizedString} */ ("Resync local data")
});